import { createStore } from 'vuex'

export default createStore({
  state: {
    dev: false,
    filters: null,
    token: null,
    modal: {
      status: false,
      data: null
    },
    user: {
      guid: null,
      data: null
    },
    tickets: [],
    requests: [],
    executors: null
  },
  getters: {
    DEV: state => {
      return state.dev;
    },
    MODAL: state => {
      return state.modal;
    },
    TOKEN: state => {
      return state.token;
    },
    FILTERS: state => {
      return state.filters;
    },
    USER: state => {
      return state.user;
    },
    TICKETS: state => {
      return state.tickets;
    },
    REQUESTS: state => {
      return state.requests;
    },
    EXECUTORS: state => {
      return state.executors;
    }
  },
  mutations: {
    DEV: (state) => {
      state.dev = !state.dev
    },
    FILTERS: (state, data) => {
      state.filters = data
    },
    MODAL: (state, data) => {
      state.modal = data
    },
    TOKEN: (state, data) => {
      state.token = data
    },
    USER_GUID: (state, data) => {
      state.user.guid = data
    },
    USER_DATA: (state, data) => {
      state.user.data = data
    },
    TICKETS: (state, data) => {
      state.tickets = data
    },
    REQUESTS: (state, data) => {
      state.requests = data
    },
    EXECUTORS: (state, data) => {
      state.executors = data
    },
  },
  actions: {
    DEV: (context) => {
      context.commit('DEV');
    },
    MODAL: (context, data) => {
      context.commit('MODAL', data)
    },
    TOKEN: (context, data) => {
      context.commit('TOKEN', data);
    },
    FILTERS: (context, data) => {
      context.commit('FILTERS', data);
    },
    USER_GUID: (context, data) => {
      context.commit('USER_GUID', data);
    },
    USER_DATA: (context, data) => {
      context.commit('USER_DATA', data);
    },
    TICKETS: (context, data) => {
      context.commit('TICKETS', data);
    },
    REQUESTS: (context, data) => {
      context.commit('REQUESTS', data);
    },
    EXECUTORS: (context, data) => {
      context.commit('EXECUTORS', data);
    }
  }
})
